import styled, { css } from 'styled-components';
import { B as Box } from '../Box/Box-BPZ8tqkL.js';

/* eslint-disable import/prefer-default-export */
const GridBox = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-40019274__sc-1du5djg-0"
})(["display:", ";border-radius:unset;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], ({
  $inline
}) => $inline ? 'inline-grid' : 'grid', ({
  $columns
}) => css(["grid-template-columns:", ";"], $columns), ({
  $rows
}) => css(["grid-template-rows:", ";"], $rows), ({
  $areas
}) => css(["grid-template-areas:", ";"], $areas), ({
  $alignContent
}) => css(["align-content:", ";"], $alignContent), ({
  $justifyContent
}) => css(["justify-content:", ";"], $justifyContent), ({
  $placeContent
}) => css(["place-content:", ";"], $placeContent), ({
  $alignItems
}) => css(["align-items:", ";"], $alignItems), ({
  $justifyItems
}) => css(["justify-items:", ";"], $justifyItems), ({
  $placeItems
}) => css(["place-items:", ";"], $placeItems), ({
  theme,
  $columnGap
}) => {
  var _theme$spacing;
  return css(["column-gap:", ";"], (_theme$spacing = theme.spacing[$columnGap || 'none']) === null || _theme$spacing === void 0 ? void 0 : _theme$spacing.default);
}, ({
  theme,
  $rowGap
}) => {
  var _theme$spacing2;
  return css(["row-gap:", ";"], (_theme$spacing2 = theme.spacing[$rowGap || 'none']) === null || _theme$spacing2 === void 0 ? void 0 : _theme$spacing2.default);
}, ({
  $autoColumns
}) => css(["grid-auto-columns:", ";"], $autoColumns), ({
  $autoRows
}) => css(["grid-auto-rows:", ";"], $autoRows), ({
  $autoFlow
}) => css(["grid-auto-flow:", ";"], $autoFlow));

export { GridBox as G };
//# sourceMappingURL=Grid.styles-4mFLxfz1.js.map
